export default {
  modalBackground: Styles.color.grey.five,
  disclaimerColor: Styles.color.grey.one,
};
